/* eslint-disable @typescript-eslint/no-unused-vars */
import { PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit'; // 引入rtk模板依赖
import { getHomePage, getModuleCourse, homePreview } from '@cap/share/src/apis/home';
import { getQueryByName } from '@cap/ssr-common-utils';

import { IHomeData, IIcon } from '@/utils/type';
import { initIcon, initCourseTab, initialState, EnumModuleCode, EnumChannelType } from '@/utils/const';
import { getDefaultIcon, getDefaultCourseTab, getModuleIdList, getModuleMap, getModuleBannerId } from '@/utils/func';
import { RootState } from '@/store';

import { LoadStatus } from '@/components/LoadPlaceholder';
// 初始化基础数据

export const getModuleContent = createAsyncThunk(
  'homeStore/getModuleContent',
  async (opt: {
    pageNo?: number;
    pageSize?: number;
    moduleIdList: number[];
    dataRule: string;
    isFirstLoad?: boolean;
  }) => {
    const res = await getModuleCourse(opt);
    return res.data;
  },
);

export const getInitData = createAsyncThunk(
  'homeStore/getInitData',
  async (_opt: { isShowLoading: boolean }, { dispatch }) => {
    const previewKey = getQueryByName('previewKey') as string;
    let res;
    if (previewKey) {
      res = await homePreview(previewKey);
    } else {
      res = await getHomePage({ clientType: [2, 3] });
    }
    // const res = await getHomePage({ clientType: [2, 3] });
    const originData = res.data.pageTabList as IHomeData[];

    const { moduleMap } = originData[0];
    if (!moduleMap) {
      return {
        originData,
        defaultIcon: initIcon,
        defaultCourseTab: initCourseTab,
      };
    }
    const defaultIcon = getDefaultIcon(originData);
    const defaultCourseTab = getDefaultCourseTab(originData);
    const dataRule = defaultIcon?.dataRule || '';
    const moduleIdList = getModuleIdList(moduleMap);
    const defaultBannerId = getModuleBannerId(moduleMap, EnumModuleCode.Banner);

    await dispatch(getModuleContent({ moduleIdList, dataRule, isFirstLoad: true }));
    return {
      originData,
      defaultIcon,
      defaultCourseTab,
      defaultBannerId,
    };
  },
);

export const homeCourseData = createSlice({
  name: 'homeCourseData',
  initialState,
  reducers: {
    resetHomeCourseData: (state, action: PayloadAction) => {
      return action.payload;
    },

    changeIcon: (state, action: PayloadAction<IIcon>) => {
      state.cpnData.curIcon = action.payload;
      if (state.cpnData.curChannel.tabType === EnumChannelType.Module) {
        state.cpnData.curCourseTab = getDefaultCourseTab(state.originData, state.cpnData.curChannel.id);
        state.cpnData.curModuleContentData = [];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInitData.pending, (state, action) => {
        const { isShowLoading } = action.meta.arg;
        return {
          ...state,
          pageLoadStatus: isShowLoading ? LoadStatus.LOADING : LoadStatus.LOADING_WITH_CONTENT,
        };
      })
      .addCase(getInitData.fulfilled, (state, action) => {
        const { originData, defaultIcon, defaultCourseTab, defaultBannerId } = action.payload;
        return {
          ...state,
          pageLoadStatus: LoadStatus.SUCCESS,
          originData,
          cpnData: {
            ...state.cpnData,
            channelList: originData,
            curChannel: originData[0],
            curIcon: defaultIcon,
            defaultBannerId,
            curCourseTab: defaultCourseTab,
          },
        };
      })
      .addCase(getInitData.rejected, (state) => {
        return {
          ...state,
          pageLoadStatus: LoadStatus.FAILURE,
        };
      });

    builder
      .addCase(getModuleContent.pending, (state, action) => {
        const { isFirstLoad } = action.meta.arg;
        return {
          ...state,
          homeDataLoadStatus: isFirstLoad ? LoadStatus.LOADING : LoadStatus.LOADING_WITH_CONTENT,
        };
      })
      .addCase(getModuleContent.fulfilled, (state, action) => {
        const moduleContentData = action.payload;
        return {
          ...state,
          homeDataLoadStatus: LoadStatus.SUCCESS,
          cpnData: {
            ...state.cpnData,
            curModuleContentData: moduleContentData,
          },
        };
      });
  },
});

export const { resetHomeCourseData, changeIcon } = homeCourseData.actions;

export const selectLoadStatus = (state: RootState) => state.homeCourseData.pageLoadStatus;
export const homeDataLoadStatus = (state: RootState) => state.homeCourseData.homeDataLoadStatus;

export const selectModuleMap = (state: RootState) =>
  getModuleMap(state.homeCourseData.cpnData.curChannel, state.homeCourseData.originData);
export const selectCurModuleContentData = (state: RootState) => state.homeCourseData.cpnData.curModuleContentData;

export const selectBannerId = (state: RootState) => state.homeCourseData.cpnData.defaultBannerId;

export const selectChannelList = (state: RootState) => state.homeCourseData.cpnData.channelList;

export const selectCurIcon = (state: RootState) => state.homeCourseData.cpnData.curIcon;

export default homeCourseData.reducer;
